import React, { useState } from 'react'
import ConfirmationModal from 'components/Shared/ConfirmationModal'
import { useTranslation } from 'react-i18next'
import { clearSales } from 'api/events'
import { useToast } from 'components/Shared/AppToast/ToastProvider'

export default function ClearSalesModal({ onCancel, eventId }) {
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const { addNotification } = useToast()

  const onConfirm = async () => {
    setIsLoading(true)
    const result = await clearSales(eventId)
    if (result.success) {
      onCancel()
      addNotification({
        message: t('Toasts.Sales.salesCleared.message'),
        description: t('Toasts.Sales.salesCleared.description'),
      })
    } else {
      addNotification({
        message: t('Toasts.Sales.salesClearedError.message'),
        description: t('Toasts.Sales.salesClearedError.description'),
        variant: 'error',
      })
    }
    setIsLoading(false)
  }

  return (
    <ConfirmationModal
      title={t('Recommendations.clearSales.title')}
      description={t('Recommendations.clearSales.description')}
      onCancel={onCancel}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  )
}